module.exports = __webpack_public_path__ + "img/pic4.4b0431de.png";